import {ClassComponent, Vnode} from 'mithril';
import IndexPage from 'flarum/forum/components/IndexPage';
import listItems from 'flarum/common/helpers/listItems';

interface PageContainerAttrs {
    showSideNav?: boolean
    narrow?: boolean
    noTheme?: boolean
}

export default class PageContainer implements ClassComponent<PageContainerAttrs> {
    view(vnode: Vnode<PageContainerAttrs, this>) {
        const pageClass = '.FormulairePage' + (vnode.attrs.noTheme ? '' : '.FormulaireTheme');

        const {
            showSideNav = true,
            narrow = false,
        } = vnode.attrs;

        if (showSideNav) {
            return m('.FormulairePageContainer', m('.container', m('.sideNavContainer', [
                m('nav.IndexPage-nav.sideNav', m('ul', listItems(IndexPage.prototype.sidebarItems().toArray()))),
                m('.sideNavOffset', m(pageClass, vnode.children)),
            ])));
        }

        return m('.FormulairePageContainer.FormulairePageContainer--noSideNav', {
            className: narrow ? 'FormulairePageContainer--narrow' : '',
        }, m('.container', m(pageClass, vnode.children)));
    }
}
